import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Reusable filter tabs component
 * @param {Object} props - Component props
 * @param {Array} props.tabs - Array of tab objects with { id, label, count?, icon? }
 * @param {string} props.activeTab - Currently active tab id
 * @param {Function} props.onTabChange - Callback when tab changes
 * @param {string} [props.className=''] - Additional CSS classes
 */
export default function FilterTabs({ tabs, activeTab, onTabChange, className = '' }) {
  return (
    <div className={`filter-tabs-container ${className}`}>
      <div className="filter-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`filter-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
          >
            {tab.icon && <FontAwesomeIcon icon={tab.icon} />}
            <span className="tab-label">{tab.label}</span>
            {tab.count !== undefined && <span className="tab-count">{tab.count}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
